var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{attrs:{"title":"统计终端用户近12月用水量","visible":_vm.showTubeView,"width":1000,"destroyOnClose":""},on:{"ok":_vm.closeTubeView,"cancel":_vm.closeTubeView}},[_c('a-row',{attrs:{"gutter":48}},[_c('a-col',{attrs:{"md":24,"sm":24}},[_c('WaterLineChart',{attrs:{"data":_vm.listData}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }